"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const C2dCoreQuadList_1 = require("./C2dCoreQuadList");
const C2dCoreQuadOperation_1 = require("./C2dCoreQuadOperation");
const C2dCoreRenderExecutor_1 = require("./C2dCoreRenderExecutor");
const C2dDefaultShader_1 = require("./shaders/C2dDefaultShader");
const C2dShader_1 = require("./C2dShader");
const Renderer_1 = require("../Renderer");
const C2dTextureTintManager_1 = require("./C2dTextureTintManager");
const C2dCoreRenderState_1 = require("./C2dCoreRenderState");
class C2dRenderer extends Renderer_1.Renderer {
    constructor(stage) {
        super(stage);
        this.tintManager = new C2dTextureTintManager_1.C2dTextureTintManager(this.stage);
        this.setupCanvasAsRenderTexture(stage.canvas);
    }
    destroy() {
        this.tintManager.destroy();
    }
    _createDefaultShader(context) {
        return new C2dDefaultShader_1.C2dDefaultShader(context);
    }
    _getShaderBaseType() {
        return C2dShader_1.C2dShader;
    }
    _getShaderAlternative(shaderType) {
        return shaderType.getC2d();
    }
    createCoreQuadList() {
        return new C2dCoreQuadList_1.C2dCoreQuadList();
    }
    createCoreQuadOperation(context, shader, shaderOwner, renderTextureInfo, scissor, index) {
        return new C2dCoreQuadOperation_1.C2dCoreQuadOperation(context, shader, shaderOwner, renderTextureInfo, scissor, index);
    }
    createCoreRenderExecutor(context) {
        return new C2dCoreRenderExecutor_1.C2dCoreRenderExecutor(context);
    }
    createCoreRenderState(context) {
        return new C2dCoreRenderState_1.C2dCoreRenderState(context);
    }
    createRenderTexture(w, h, pw, ph) {
        const canvas = document.createElement("canvas");
        canvas.width = pw;
        canvas.height = ph;
        this.setupCanvasAsRenderTexture(canvas);
        return canvas;
    }
    freeRenderTexture(renderTexture) {
        this.tintManager.delete(renderTexture);
    }
    gc(aggressive) {
        this.tintManager.gc(aggressive);
    }
    uploadTextureSource(textureSource, options) {
        // In case of Context2d, we usually do not need to upload.
        // Only in case of ArrayBuffer
        // For canvas, we do not need to upload.
        if (options.source instanceof Uint8ClampedArray) {
            // Convert RGBA buffer to canvas.
            const canvas = document.createElement("canvas");
            canvas.width = options.width;
            canvas.height = options.height;
            const imageData = new ImageData(options.source, options.width, options.height);
            canvas.getContext("2d").putImageData(imageData, 0, 0);
            return canvas;
        }
        return options.source;
    }
    freeTextureSource(textureSource) {
        this.tintManager.delete(textureSource.nativeTexture);
    }
    setupCanvasAsRenderTexture(canvas) {
        const context = canvas.getContext("2d");
        canvas.context = context;
        canvas.context.scissor = undefined;
        // Save base state so we can restore the defaults later.
        context.save();
    }
    copyRenderTexture(renderTexture, nativeTexture, options) {
        throw new Error("Copy render texture not implemented");
    }
}
exports.C2dRenderer = C2dRenderer;
//# sourceMappingURL=C2dRenderer.js.map